import { RgbInput } from './rgb-input';
import { HslInput } from './hsl-input';
import { HexInput } from './hex-input';
import { jsx as _jsx } from "react/jsx-runtime";
export const ColorInput = ({
  colorType,
  color,
  hsla,
  onChange,
  onHSLChange,
  enableAlpha
}) => {
  switch (colorType) {
    case 'hsl':
      return /*#__PURE__*/_jsx(HslInput, {
        hsla: hsla,
        onChange: onHSLChange,
        enableAlpha: enableAlpha
      });
    case 'rgb':
      return /*#__PURE__*/_jsx(RgbInput, {
        color: color,
        onChange: onChange,
        enableAlpha: enableAlpha
      });
    default:
    case 'hex':
      return /*#__PURE__*/_jsx(HexInput, {
        color: color,
        onChange: onChange,
        enableAlpha: enableAlpha
      });
  }
};